<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { agentStatistics, periodTaxStatistics, taxCalendar } from '../../../api/sye.js';
import { managementExpage, fxjk_comapny } from '../../../api/Notificationsettings.js';
export default {
	data() {
		return {
			value: new Date(),
			height: '',
			tablekey: 0,
			headData: getdata().headData,
			tableData: [{ zbmc: 1 }, { zbmc: 1 }, { zbmc: 1 }, { zbmc: 1 }, { zbmc: 1 }],
			userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
			suosq: this.$getdefultMonth(),
			statisticsdata: {
				digCount: 0,
				notFillCount: 0,
				stayAuditCount: 0,
				stayJiaokCount: 0,
				stayShenbCount: 0
			},
			suosqjd: this.$getdefultMonth(),
			plandata: {
				completeQiyCount: '0',
				qiyCount: '0',
				jiaokCompleteSum: '0',
				completeSum: '0',
				fillIngCount: '0',
				submitCount: '0',
				auditIngCount: '0',
				auditCompleteCount: '0',
				stayShenbCount: '0',
				shenbCompleteCount: '0',
				jiaokCompleteCount: '0',
				jiaokFailureCount: '0'
			},
			taxStartAndStopDate: [],
			tableData: [],
			companyCode: '',
			options: []
		};
	},
	created() {
	},
	mounted() {
		this.initialize();
		this.Height();
		this.initializeqzsj();
		this.initializejd();
		this.chaxgs();
		const _this = this;
		window.addEventListener('resize', () => {
			_this.Height();
		});
	},
	watch: {
		value(val, oldVal) {
			this.initializeqzsj();
		}
	},
	methods: {
		currStationChange(v) {
			this.balancePage();
		},
		chaxgs() {
			fxjk_comapny().then(res => {
				this.options = res.data.data.map(v => {
					return {
						value: v.companyCode,
						label: v.nsrmc
					};
				});
				this.companyCode = this.options[0].value;
				this.balancePage();
			});
		},
		ViewAll() {
			this.$router.push({
				path: '/fxjk'
			});
		},
		balancePage() {
			let params = {};
			params.companyCode = this.companyCode;
			params.current = 1;
			params.size = 5;
			params.suosq = this.suosq
			managementExpage(params).then(res => {
				if (res.data.code == 1) {
					this.tableData = res.data.data.records;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		initializeqzsj() {
			let myDate = new Date(this.value);
			let Datey = (myDate.getMonth() + 1).toString().length < 2 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1;
			let params = {
				date: myDate.getFullYear() + '-' + Datey,
				dqCode: ''
			};
			taxCalendar(params).then(res => {
				if (res.data.code == 1) {
					this.taxStartAndStopDate = res.data.data.taxStartAndStopDate;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		initialize() {
			let params = {
				suosq: this.suosq
			};
			agentStatistics(params).then(res => {
				if (res.data.code == 1) {
					this.statisticsdata = res.data.data;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		initializejd() {
			let params = {
				suosq: this.suosqjd
			};
			periodTaxStatistics(params).then(res => {
				if (res.data.code == 1) {
					this.plandata = res.data.data;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		Height() {
			document.getElementsByClassName('table')[0].style.height = '';
			let one = this.$refs.refboxone.offsetHeight;
			let two = this.$refs.refboxtwo.offsetHeight;
			this.height = one + two  + 52 + 16 + 16 + 16+354 > window.innerHeight ? '' : window.innerHeight - (one + 52 + 16 + 150 +354) + 'px';
			document.getElementsByClassName('table')[0].style.height = this.height;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
